import { searchOptions } from '@/shared/utils/search-options.util';

import { Option } from './searchable-select.types';

export const searchSelectOptions = (query: string, options: Option<string>[]) => {
	if (!query) {
		return {
			filteredOptions: options,
			firstMatchIndex: -1,
		};
	}

	const filteredOptions = searchOptions(query, options);

	return { filteredOptions, firstMatchIndex: filteredOptions.length > 0 ? 0 : -1 };
};
